"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _DeskingQuestionsModel = _interopRequireDefault(require("../models/DeskingQuestionsModel"));

var _VehicleCondition = _interopRequireDefault(require("./VehicleCondition/VehicleCondition"));

// we can include a different model if need be
var XMSConditionForm = function XMSConditionForm(props) {
  return /*#__PURE__*/_react.default.createElement(_VehicleCondition.default, (0, _extends2.default)({
    Model: _DeskingQuestionsModel.default
  }, props));
};

var _default = XMSConditionForm;
exports.default = _default;